import * as React from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';

import { default as RegistrationContainer } from '../Registration/RegistrationContainer';
import { default as RegistrationSendCodeContainer } from '../Registration/RegistrationSendCodeContainer';
import { default as RegistrationIsSendCodeContainer } from '../Registration/RegistrationIsSendCodeContainer';
import { default as RegistrationSuccessContainer } from '../Registration/Success/SuccessContainer';
import { default as AuthorizationContainer } from '../Authorization/AuthorizationContainer';
import { default as AuthorizationSendCodeContainer } from '../Authorization/AuthorizationSendCodeContainer';
import { default as AuthorizationIsSendCodeContainer } from '../Authorization/AuthorizationIsSendCodeContainer';
import { default as AuthorizationSuccessContainer } from '../Authorization/Success/SuccessContainer';

import { default as HomeCleverBotContainer } from '../CleverBot/Home/HomeCleverBotContainer';

import { default as HomeTravelsContainer } from '../Travels/Home/HomeTravelsContainer';

import { default as HomeOnlineOtpContainer } from '../OnlineOtp/Home/HomeOnlineOtpContainer';

import { NotFound } from '../Shared/NotFound/NotFound';
import HomeTelemedicineContainer from '../Telemedicine/Home/HomeTelemedicineContainer';
import OpenedCountriesHomeContainer from '../OpenedCountries/OpenedCountriesHomeContainer';
import { SpecialPageContainer } from '../../GPBMobile/SpecialPageContainer';
import PromocodesContainer from '../Promocodes/PromocodesContainer';
import HomeVtbMedicalContainer from '../VtbMedical/HomeVtbMedicalContainer';
import { AirbackInfoPageContainer } from '../../K24Mobile/AirbackInfoPageContainer';
import { YouTravelPageContainer } from '../../YouTravel/YouTravelPageContainer';
import { YouTravelSearchPageContainer } from '../../YouTravel/search/YouTravelSearchPageContainer';
import { AlfaTransfersPageContainer } from '../AlfaTransfers/AlfaTransfersPageContainer';
import { AiroPageContainer } from '../Airo/AiroPageContainer';
import { SimpleWinePageContainer } from '../SimpleWine/SimpleWinePageContainer';
import { TransferRulesPageContainer } from '../../K24Mobile/TransferRulesPageContainer';
import './../Requests/Requests.scss';
import './../Restaurans/Order/OrderDetailsView.scss';
import HotelPoliciesContainer from '../Hotels/Hotel/HotelPolicies/HotelPoliciesContainer';

class App extends React.Component {
    render() {
        return (
            <HashRouter>
                <Switch>
                    <Redirect exact={true} from='/' to='/authorization' />

                    <Route exact={true} path='/registration' component={RegistrationContainer} />
                    <Route exact={true} path='/registration/sendCode' component={RegistrationSendCodeContainer} />
                    <Route exact={true} path='/registration/isSendCode' component={RegistrationIsSendCodeContainer} />
                    <Route exact={true} path='/registration/success' component={RegistrationSuccessContainer} />
                    <Route exact={true} path='/authorization' component={AuthorizationContainer} />
                    <Route exact={true} path='/authorization/sendCode' component={AuthorizationSendCodeContainer} />
                    <Route exact={true} path='/authorization/isSendCode' component={AuthorizationIsSendCodeContainer} />
                    <Route exact={true} path='/authorization/success' component={AuthorizationSuccessContainer} />

                    <Route path='/hotels/hotel-policies' component={HotelPoliciesContainer} />

                    <Route exact={true} path='/clever_bot' component={HomeCleverBotContainer} />

                    <Route exact={true} path='/travels' component={HomeTravelsContainer} />
                    <Route exact={true} path='/online_otp' component={HomeOnlineOtpContainer} />
                    <Route exact={true} path='/telemedicine' component={HomeTelemedicineContainer} />
                    <Route exact={true} path='/vtb_medical' component={HomeVtbMedicalContainer} />

                    <Route exact={true} path='/opened_countries' component={OpenedCountriesHomeContainer} />
                    <Route exact={true} path='/promocodes/:type_key' component={PromocodesContainer} />

                    <Route exact={true} path='/gpb-mobile/special_page' component={SpecialPageContainer} />
                    <Route exact={true} path='/k24-mobile/airback_info' component={AirbackInfoPageContainer} />
                    <Route exact={true} path='/business_lounges' component={AirbackInfoPageContainer} />
                    <Route exact={true} path='/dragon_pass' component={AirbackInfoPageContainer} />
                    <Route exact={true} path='/lounges_rules' component={AirbackInfoPageContainer} />
                    <Route exact={true} path='/transfer_rules' component={TransferRulesPageContainer} />
                    <Route exact={true} path='/you_travel' component={YouTravelPageContainer} />
                    <Route exact={true} path='/you_travel/search' component={YouTravelSearchPageContainer} />
                    <Route exact={true} path='/alfa_transfers' component={AlfaTransfersPageContainer} />
                    <Route exact={true} path='/airo' component={AiroPageContainer} />
                    <Route exact={true} path='/simplewine' component={SimpleWinePageContainer} />

                    <Route path='*' component={NotFound} />

                </Switch>
            </HashRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.tsx